import React from "react";

const RefundPolicy = () => {
  return (
    <div className="container my-5" style={{ maxWidth: "70%" }}>
      <h1 className="mb-4 fw-bold">Return & Refund Policy</h1>

      <p>
        This Return & Refund Policy applies to all purchases made through
        PassionateWorldUniversity.com. By placing an order for any of our
        digital services or products, you acknowledge and agree to this policy.
      </p>

      <h5 className="mt-4 mb-2">Digital Products & Services</h5>
      <p>
        We offer non-tangible, digital services and products such as consulting
        sessions, online courses and trainings, speaking sessions, community/podcast access, downloadable content, and other digital materials.
        Due to the nature of these services, <strong>all sales are final and non-refundable</strong>.
      </p>

      <p>
        Once access to a digital service or product has been granted (for example:
        a consultation is booked, a course is accessed, or community content is made available), we are unable to offer cancellations, returns, or exchanges.
      </p>

      <h5 className="mt-4 mb-2">Special Circumstances</h5>
      <p>
        In rare and exceptional cases, at the sole discretion of Passionate World University, a refund request may be reviewed. If a refund is approved, it will be issued within <strong>7–10 business days</strong> from the date of approval.
      </p>

      <h5 className="mt-4 mb-2">No General Refunds</h5>
      <p>
        Please review each service carefully before purchasing. We do not
        provide partial or full refunds under normal circumstances.
      </p>

      <h5 className="mt-4 mb-2">Contact</h5>
      <p>
        If you need further clarification about this Return & Refund Policy, you
        may contact us at{" "}
        <a href="mailto:support@passionateworlduniversity.com" className="text-primary">
          support@passionateworlduniversity.com
        </a>
        .
      </p>
    </div>
  );
};

export default RefundPolicy;
